import { apiClient } from '@/lib/api/api-client'
import type { DashboardResponse } from '../types/dashboard'

const DASHBOARD_ENDPOINT = 'dashboard'

export const dashboardApi = {
  getDashboard: () => apiClient.get<DashboardResponse>(DASHBOARD_ENDPOINT),
}
